import { toAbsoluteUrl } from "./url";

const escapeHtml = (s = "") =>
  String(s)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

export const printIngredientsSheet = ({
  dishName = "",
  dishImage = "",
  affiliateName = "",
  affiliateImage = "",
  ingredientsText = "",
  labels = {
    title: "Innehållsförteckning",
    generatedAt: "Skapad",
    openWindowError: "Kunde inte öppna utskriftsfönster",
  },
}) => {
  const safeLabels = {
    title: labels?.title || "Innehållsförteckning",
    generatedAt: labels?.generatedAt || "Uppdaterad",
    openWindowError:
      labels?.openWindowError || "Kunde inte öppna utskriftsfönster",
  };

  const absoluteDishImageUrl = toAbsoluteUrl(dishImage);
  const absoluteAffiliateImageUrl = toAbsoluteUrl(affiliateImage);
  const poweredByLogoUrl = toAbsoluteUrl("/assets/images/consupedia_logo_blue.svg");
  const generatedAt = new Date().toLocaleString("sv-SE");
  const hasDishImage = Boolean(absoluteDishImageUrl);
  const hasAffiliateImage = Boolean(absoluteAffiliateImageUrl);

  const dishLogoHtml = hasDishImage
    ? `<img class="logo" src="${escapeHtml(
        absoluteDishImageUrl
      )}" alt="Rättbild" />`
    : `<div class="logo logo-fallback" aria-hidden="true">${escapeHtml(
        (dishName || "?").toString().trim().charAt(0).toUpperCase() || "?"
      )}</div>`;

  const affiliateHtml = hasAffiliateImage
    ? `<div class="affiliate"><img class="affiliate-logo" src="${escapeHtml(
        absoluteAffiliateImageUrl
      )}" alt="Affiliate" /><p class="sub">${escapeHtml(affiliateName)}</p></div>`
    : `<p class="sub">${escapeHtml(affiliateName)}</p>`;

  const contentHtml = `
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtml(dishName)} - ${escapeHtml(safeLabels.title)}</title>
        <style>
          @page { size: A4; margin: 14mm; }
          body { font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif; color: #1f2937; margin: 0; background: #fff; }
          .sheet { width: 100%; box-sizing: border-box; border: 1px solid #e5e7eb; border-radius: 16px; padding: 18px; }
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding-bottom: 12px; margin-bottom: 14px; }
          .brand { display: flex; align-items: center; gap: 12px; }
          .logo { width: 46px; height: 46px; border-radius: 10px; object-fit: cover; border: 1px solid #e5e7eb; }
          .logo-fallback { display: inline-flex; align-items: center; justify-content: center; background: #f3f4f6; color: #6b7280; font-size: 18px; font-weight: 700; }
          .affiliate { display: flex; align-items: center; gap: 8px; margin-top: 4px; }
          .affiliate-logo { width: 20px; height: 20px; border-radius: 9999px; object-fit: cover; border: 1px solid #e5e7eb; background: #fff; }
          .title { font-size: 22px; font-weight: 700; margin: 0; line-height: 1.2; }
          .sub { margin: 4px 0 0; color: #6b7280; font-size: 12px; }
          .meta { margin: 0 0 12px; color: #6b7280; font-size: 12px; }
          .section-title { font-size: 14px; text-transform: uppercase; letter-spacing: 0.04em; color: #6b7280; margin: 0 0 8px; }
          .ingredients { border: 1px solid #e5e7eb; border-radius: 12px; padding: 14px; white-space: pre-wrap; line-height: 1.65; font-size: 14px; }
          .powered-by { margin-top: 10px; display: flex; align-items: center; justify-content: flex-end; gap: 6px; color: #9ca3af; font-size: 10px; }
          .powered-by-logo { height: 14px; width: auto; opacity: 0.8; }
        </style>
      </head>
      <body>
        <div class="sheet">
          <div class="header">
            <div class="brand">
              ${dishLogoHtml}
              <div>
                <h1 class="title">${escapeHtml(dishName)}</h1>
                ${affiliateHtml}
              </div>
            </div>
          </div>
          <p class="meta">${escapeHtml(safeLabels.generatedAt)}: ${escapeHtml(generatedAt)}</p>
          <div style="flex:1">
            <p class="section-title">${escapeHtml(safeLabels.title)}</p>
            <div class="ingredients">${escapeHtml(ingredientsText)}</div>
            <div class="powered-by">
              <span>Menuwiz - powered by</span>
              <img class="powered-by-logo" src="${escapeHtml(poweredByLogoUrl)}" alt="Consupedia" />
            </div>
          </div>
        </div>
      </body>
    </html>
  `;

  const printViaIframeFallback = () => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);

    const cleanup = () => {
      setTimeout(() => {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }, 1000);
    };

    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc || !iframe.contentWindow) {
      console.error(safeLabels.openWindowError);
      cleanup();
      return;
    }

    iframeDoc.open();
    iframeDoc.write(contentHtml);
    iframeDoc.close();
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow?.print();
      cleanup();
    }, 250);
  };

  // Iframe-first printing avoids extra about:blank popup tabs.
  printViaIframeFallback();
};

